import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { WithStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import AddIcon from "@material-ui/icons/Add";
import { GREEN_COLOR, RED_COLOR } from "../../constants/style-constants";

const styles = createStyles({
    scheduleActions: {
        display: "flex",
        justifyContent: "start"
    },
    addScheduleActionButton: {
        margin: 5,
        backgroundColor: GREEN_COLOR,
        color: "white"
    },
    deleteScheduleActionButton: {
        margin: 5,
        backgroundColor: RED_COLOR,
        color: "white"
    }
});

const ScheduleActions = (props: WithStyles<typeof styles> & RouteComponentProps) => {
    const { classes, history } = props;
    const createSchedule = () => {
        history.replace("/schedule/");
    };
    return (
        <div className={classes.scheduleActions}>
            <Button variant="contained" className={classes.addScheduleActionButton} onClick={createSchedule}>
                <AddIcon />
                Add schedule
            </Button>
        </div>
    );
};
export default withStyles(styles)(withRouter(ScheduleActions));
